import { useTranslation } from "react-i18next"

export default function LoadingReading() {
  const { t } = useTranslation()
  return (
    <>
      <div style={{textAlign: 'center'}}><div className="lds-ripple"><div></div><div></div></div></div>
      <div className="ast_blog_post">{t('loading_message')}</div>
    </>
  )
}